
export default {
  data() {
    return {
      form: {
        score_environment: 0,
        score_security: 0,
        score_transportation: 0,
        score_health: 0,
        score_education: 0,
        score_sport: 0,
        score_services: 0,
        score_culture: 0,
        score_global: this.initScoreGlobal ? this.initScoreGlobal : 0,
        body: null,
      },
      errors: {},
      notSubmitted: true,
    };
  },
  created() {
    this.$nuxt.$on('successfully-logged', (data) => {
      if (data && data.next === 'submitReview') {
        this.submit();
      }
    });
  },
  beforeDestroy() {
    this.$nuxt.$off('successfully-logged');
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.reviewForm.validate();
      if (isValid) {
        if (this.$auth.loggedIn) {
          this.$axios
            .$post(`/api/cities/${this.city.slug}/reviews`, this.form)
            .then((response) => {
              this.notSubmitted = false;
            })
            .catch((error) => {
              if (error.response && error.response.status === 422) {
                // this.errors = error.response.data.errors;
                this.$refs.profileForm.setErrors(error.response.data.errors);
              } else {
                alert(
                  'Une erreur est survenue, veuillez réessayer ultérieurement.'
                );
              }
            });
        } else {
          this.$nuxt.$emit('open-login-modal', {
            mode: 'login',
            next: 'submitReview',
          });
        }
      }
    },
  },
  props: {
    city: Object,
    token: String,
    initScoreGlobal: Number,
  },
};
